const targets = document.querySelectorAll('.scroll_content_slide');
const scroll_appear = (target) => {
	const io = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('active_content');
					const imgId = entry.target.dataset.imgId;
					document.getElementById(imgId)?.classList.add('active_img');
				} else {
					entry.target.classList.remove('active_content');
					const imgId = entry.target.dataset.imgId;
					document.getElementById(imgId)?.classList.remove('active_img');
				}
			});
		},
		{ threshold: [0.25] }
	);

	io.observe(target);
};
targets.forEach(scroll_appear);
